export class MemberNeedingSmsResponse
{
    Id!: number;
    NeedsSmsReplyFromOrgInLast24Hours = false;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }
}
